import { faChartPie, faFileAlt } from '@fortawesome/free-solid-svg-icons'
import React, { useContext, useEffect, useState } from 'react'
import { LanguageContext } from '../Language/LanguageContext'
import { Container, TabButton } from '../Library'
import { BrowserRouter, Route } from 'react-router-dom'
import './Visitor.css'
import Dashboard from './Dashboard'
import VisitorReport from './VisitorReport'
import VisitorSecurity from './VisitorSecurity'
import VisitorEdit from './VisitorEditSecurity'
import VisitorCreate from './VisitorSecurityCreate'
import VisitorOrganizeCar from './VisitorOrganizeCar'
import VisitorOrganizeCarCreate from './VisitorOrganizeCarCreate'
import VisitorOrganizeCarShow from './VisitorOrganizeCarShow'
import VisitorOrganizeCarAddUser from './VisitorOrganizeCarAddUser'
import VisitorAllUser from './VisitorAllUser'
import { Switch } from 'react-router-dom'
import { setDocumentTitle } from '../AppTitle'
import { Form } from 'react-bootstrap'
import { listCompany } from '../Network/Company'
import { NotifyContext } from '../Library/Notify'

function Visitor() {
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.visitor

    const [companyList, setCompanylist] = useState([]);
    const [isLoading, setLoading] = useState(false);
    const [chooseCompany, setChooseCompany] = useState();
    const [chooseCompanyId, setChooseCompanyId] = useState();
    const notifyCx = useContext(NotifyContext)

    const fetchList = () =>{
        setLoading(true)
        listCompany(
            (data)=>{
                if(localStorage.getItem("building_id") == 5){
                    setChooseCompany('Waveplace')
                }else{
                    setChooseCompany(data[0].name)
                    setChooseCompanyId(data[0].id)
                    setCompanylist(data)               
                }
                setLoading(false)
            }, 
            (error)=>{
                notifyCx.showNotify("Something wrong", error.message, 2)
                setLoading(false)
            }
        )
    }

    useEffect( async ()=>{
        setDocumentTitle("Visitor")
        console.log(localStorage.getItem("building_id"))
        listCompany(
            (data)=>{
                if(localStorage.getItem("building_id") == 5){
                    setChooseCompany(data[21].name)
                }else{
                    setChooseCompany(data[0].name)
                    setChooseCompanyId(data[0].id)
                    setCompanylist(data)
                }
                setLoading(false)
            },
            (error)=>{
                notifyCx.showNotify("Something wrong", error.message, 2)
                setLoading(false)
            }
        )
        fetchList()
    },[])

    const handleChange = (e) => {
        const id = e.target.value; // string    
        setChooseCompanyId(id);
      
        // หา name จากรายการ (หรือกรณีพิเศษ)
        if (localStorage.getItem("building_id") == 5) {
          setChooseCompany("Waveplace");
        } else {
          const found = companyList.find(
            (x) => String(x.id) === String(id) && x.type === "OFFICE"
          );
          setChooseCompany(found?.name ?? "");
        }
    }

    return (
        <Container topbarTitle={lang.visitor}>
            <BrowserRouter basename='/visitor'>
                <div className='nav-container'>
                    <div className='nav-left'>
                        <TabButton title={lang.dashboard} icon={faChartPie} to='/' exact={true}/>
                        <TabButton title={lang.visitor_report} icon={faFileAlt} to='/visitor_report'/>
                        <TabButton title={lang.visitor_security_guard} icon={faFileAlt} to='/visitor_security'/>
                        <TabButton title={'จัดการรถเข้าออก'} icon={faFileAlt} to='/visitor_organize_car'/>
                        <TabButton title={'ผู้ใช้งานระบบ'} icon={faFileAlt} to='/visitor_user'/>
                    </div>
                    <div className='nav-right'>
                            <Form.Control as="select" 
                                value={chooseCompanyId} 
                                onChange={handleChange}
                            >
                                {   
                                localStorage.getItem("building_id") == 5?
                                        <option value={'Waveplace'}>{'Waveplace'}</option> :
                                   companyList.filter(item => item.type == 'OFFICE').map((item, key) =>
                                        <option value={item.id} key={item.id}>{item.name}</option>
                                   )
                                }
                            </Form.Control>
                    </div>
                </div>
                <hr/>
                <Switch>
                    <Route path="/" render={(props) => <Dashboard {...props} companyId={chooseCompanyId} company={chooseCompany}  />}  exact>
                    </Route>
                    <Route path="/visitor_report" render={(props) => <VisitorReport {...props} companyId={chooseCompanyId} company={chooseCompany} />} exact>
                    </Route>
                    <Route path="/visitor_security" render={(props) => <VisitorSecurity {...props} companyId={chooseCompanyId} company={chooseCompany} />} exact>
                    </Route>
                    <Route path="/visitor_security/edit/:securityId" render={(props) => <VisitorEdit {...props} companyId={chooseCompanyId} company={chooseCompany} />}>
                    </Route>
                    <Route path="/visitor_security/create" render={(props) => <VisitorCreate {...props} companyId={chooseCompanyId} company={chooseCompany}/>} >
                    </Route>
                    <Route path="/visitor_organize_car" render={(props) => <VisitorOrganizeCar {...props} companyId={chooseCompanyId} company={chooseCompany}/>} exact>
                    </Route>
                    <Route path="/visitor_organize_car/create" render={(props) => <VisitorOrganizeCarCreate {...props} companyId={chooseCompanyId} company={chooseCompany}/>} >
                    </Route>
                    <Route path="/visitor_organize_car/show/:carID" render={(props) => <VisitorOrganizeCarShow {...props} companyId={chooseCompanyId} company={chooseCompany}/>} >
                    </Route>
                    <Route path="/visitor_organize_car/adduser/:carID" render={(props) => <VisitorOrganizeCarAddUser {...props} companyId={chooseCompanyId} company={chooseCompany}/>} >
                    </Route>
                    <Route path="/visitor_user" render={(props) => <VisitorAllUser key={chooseCompanyId ?? 0} {...props} companyId={chooseCompanyId} company={chooseCompany} /> } exact>
                    </Route>
                </Switch>
            </BrowserRouter>
        </Container>
    )
}


export default Visitor
